import TeamStore from "../store";
import { action } from "satcheljs/lib/legacy";

export let updateTimeClockEnabled = action("updateTimeClockEnabled")(
    /**
     * Updates the time clock enabled setting of the current team
     */
    function updateTimeClockEnabled(timeClockEnabled: boolean) {
        TeamStore().team.timeClockEnabled = timeClockEnabled;
    });